"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.date.to-string");exports.__esModule = true;exports.default = void 0;

var _is = require("../../is");
var _setTimePartToStartEnd = _interopRequireDefault(require("../setTimePartToStartEnd"));



function ceilMonth(start, end) {
  return {
    start: (0, _setTimePartToStartEnd.default)(start, 'w', 'start'),
    end: (0, _setTimePartToStartEnd.default)(end, 'w', 'end') };

}


function getRangeFromMiddle(arg, opts) {var
  partName = arg.partName,ts = arg.ts;

  var start = (0, _setTimePartToStartEnd.default)(new Date(ts), partName, 'start');
  var end = (0, _setTimePartToStartEnd.default)(new Date(ts), partName, 'end');

  if (partName === 'M' && (0, _is.isObj)(opts) && opts.ceilMonth === true) {var _ceilMonth =
    ceilMonth(start, end);start = _ceilMonth.start;end = _ceilMonth.end;
  }

  return {
    start: start,
    end: end,
    partName: partName };

}var _default =




{
  getRangeFromMiddle: getRangeFromMiddle };exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/Range/utils.js
// module id = 309
// module chunks = 0